import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Event } from './Event';
import { EVENTS_I_AM_ADMIN_OF, EVENTS_I_HOST } from './SecurityRules';
import { UserSimpleView } from './UserSimpleView';

export interface EventCoHostRow {
  id: number;
  event_id: number;
  user_id: string | null;
  email_address: string;
  status: string;
}

export const EventCoHost: Entity<EventCoHostRow> = {
  id: 'EventCoHost',
  title: 'Event Co-Host',
  service: 'main',
  rowLabel: (row: EventCoHostRow) => row.email_address || row.user_id || String(row.id),
  rowLabelDynamic: (row: EventCoHostRow) =>
    row.user_id ? `<lookup:UserView:${row.user_id}> / <lookup:Event:${row.event_id}>` : row.email_address,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.event_co_host',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `user_id = '{userId}' OR event_id IN ${EVENTS_I_HOST}`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `user_id = '{userId}' OR event_id IN ${EVENTS_I_HOST} OR event_id IN ${EVENTS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['event_id', 'ASC']],
  defaultFilters: [{ fieldId: 'event_id', operator: 'eq', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    event_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Event',
      mandatory: true,
      refEntity: Event,
    },
    email_address: {
      seq: 20,
      type: FieldType.Text,
      label: 'Email Address',
      mandatory: true,
      listColumn: true,
      maxLength: 255,
    },
    status: {
      seq: 25,
      type: FieldType.Options,
      label: 'Status',
      options: [
        { id: 'not-registered', label: 'not registered' },
        { id: 'registered', label: 'registered' },
      ],
      persistence: PersistenceType.FrontEndOnly,
      listColumn: true,
      evaluateFrontEndIn: (row: EventCoHostRow) => (row.user_id ? 'registered' : 'not-registered'),
    },
    user_id: {
      seq: 30,
      type: FieldType.Reference,
      label: 'User',
      mandatory: false,
      listColumn: true,
      refEntity: UserSimpleView,
    },
  },
};
